// src/pages/bloomterminal/alerts/components/NavigationButtons.jsx
import React from 'react';
import { useGlobalFontSize } from '../../../context/GlobalFontSizeContext';

const NavigationButtons = ({
  onPrevious,
  onNext,
  previousDisabled = false,
  nextDisabled = false,
  nextButtonText = 'Next',
  nextButtonLoading = false,
}) => {
  const { fontSize } = useGlobalFontSize();
  return (
    <div className="flex flex-col gap-6 items-center">
      <div className="flex gap-4 items-center">
        <button
          onClick={onPrevious}
          disabled={previousDisabled}
          className={`w-[100px] h-10 px-[20px] py-[12px] border border-solid rounded-[8px] bg-transparent flex items-center justify-center font-['Helvetica_Neue'] font-medium transition-colors ${
            previousDisabled
              ? 'border-[#5d625f] text-[#5d625f] cursor-not-allowed opacity-50'
              : 'border-[#828382] text-[#828382] hover:text-[#282A29] hover:border-[#282A29] dark:hover:text-[#f0f5f2] dark:hover:border-[#f0f5f2]'
          }`}
          style={{ fontSize: fontSize + 2 }}
        >
          Back
        </button>
        <button
          onClick={onNext}
          disabled={nextDisabled || nextButtonLoading}
          className={`w-[100px] h-10 px-[20px] py-[12px] rounded-[8px] bg-bloom-green flex items-center justify-center font-['Helvetica_Neue'] font-medium transition-colors ${
            nextDisabled || nextButtonLoading
              ? 'bg-[#5d625f] text-[#828382] cursor-not-allowed opacity-50'
              : 'text-white hover:bg-bloom-green-hover'
          }`}
          style={{ fontSize: fontSize + 2 }}
        >
          {nextButtonLoading ? 'Loading...' : nextButtonText}
        </button>
      </div>
    </div>
  );
};

export default NavigationButtons;

